<template>
    <li>
      <div class="feature-icon" v-html="features_icons[f.internal_name]"></div>
      <div class="desc"><span v-html="f.name"></span></div>
    </li>
</template>

<script>
export default {
  name: 'BikeFeatures',
  props: {
    f: {
      type: Object,
    }
  },
  data () {
    return {
      features_icons: {
        'bell': `<svg viewBox="0 0 22.624 22.677" >
                          <path d="M0.374,14.386c1.333,4.779,5.708,8.291,10.912,8.291c6.262,0,11.338-5.076,11.338-11.338
                              c0-0.064-0.008-0.125-0.009-0.189C22.514,4.976,17.485,0,11.286,0c-1.207,0-2.368,0.192-3.459,0.541
                              c3.694,0.761,6.531,4.983,6.531,11.845H0c0.031,0.339,0.082,0.671,0.142,1h14.607c0.446,0,0.808,0.049,0.808,0.5
                              s-0.362,0.5-0.808,0.5H7.307c0.629,1,1.074,1.255,1.074,1.981c0,0.954-0.763,1.916-1.704,1.916c-0.942,0-1.705-1.059-1.705-2.012
                              c0-0.727,0.446-0.886,1.074-1.886H0.374z"/>
                          </svg>`,

        'front-rack': `<svg  viewBox="0 0 22.676 22.679">
                                  <path d="M11.822,12.97c-1.531-0.739-3.234-1.247-5.011-1.247c-2.37,0-4.632,0.665-6.57,1.999C0.084,12.971,0,12.351,0,11.553
                                      c0-0.191,0.018-0.409,0.028-0.409h12.529L11.822,12.97z"/>
                                  <path d="M22.676,11.302c0,3.732-1.813,7.098-4.6,9.162c-0.711-2.865-2.482-5.12-4.843-6.693l1.028-2.627h1.938
                                      c0.539,0,0.974-0.462,0.974-1c0-0.537-0.436-1-0.976-1h-0.001H0.212C1.225,4.143,5.818,0,11.338,0
                                      C17.601,0,22.676,5.045,22.676,11.302"/>
                                  <path d="M12.665,15.144c1.95,1.41,3.398,3.501,3.932,5.962c0.018,0.085,0.052,0.16,0.093,0.231
                                      c-1.593,0.854-3.416,1.342-5.351,1.342c-0.475,0-0.94-0.038-1.399-0.095L12.665,15.144z"/>
                                  <path d="M0.918,15.146c1.719-1.253,3.757-1.916,5.893-1.916c1.586,0,3.102,0.388,4.458,1.067l-2.918,7.971
                                      c-3.548-0.968-6.395-3.606-7.65-7.023C0.777,15.22,0.852,15.195,0.918,15.146"/>
                              </svg>`,

        'rear-rack': `<svg viewBox="0 0 22.676 22.599">
                                  <path d="M10.854,12.916c1.531-0.735,3.234-1.232,5.011-1.232c2.37,0,4.631,0.667,6.57,1.995c0.156-0.748,0.241-1.381,0.241-2.176
                                      c0-0.19-0.019-0.423-0.028-0.423H10.119L10.854,12.916z"/>
                                  <path d="M9.443,13.713l-1.028-2.634H6.517l-1.104,2.347c-0.132,0.298-0.425,0.395-0.734,0.395c-0.107,0-0.215-0.062-0.32-0.106
                                      c-0.405-0.178-0.59-0.709-0.412-1.111l1.525-3.524h16.992C21.452,4.079,16.858,0,11.338,0C5.076,0,0,5.071,0,11.299
                                      c0,3.716,1.813,7.094,4.6,9.148C5.31,17.593,7.082,15.278,9.443,13.713"/>
                                  <path d="M10.011,15.098c-1.95,1.403-3.398,3.484-3.932,5.936c-0.018,0.084-0.052,0.159-0.093,0.229
                                      c1.593,0.852,3.416,1.336,5.351,1.336c0.475,0,0.94-0.038,1.399-0.095L10.011,15.098z"/>
                                  <path d="M21.757,15.101c-1.719-1.248-3.757-1.907-5.893-1.907c-1.586,0-3.102,0.386-4.458,1.062l2.918,7.936
                                      c3.548-0.963,6.395-3.59,7.649-6.991C21.899,15.173,21.823,15.15,21.757,15.101"/>
                              </svg>`,

        'fenders': `<svg viewBox="0 0 22.678 21.502">
                                  <path d="M16.339,0v12.135c0,2.762-2.238,5-5,5c-2.762,0-5-2.238-5-5V0C2.588,1.849,0,5.7,0,10.165
                                      c0,6.262,5.076,11.337,11.339,11.337c6.262,0,11.339-5.075,11.339-11.337C22.678,5.7,20.09,1.849,16.339,0"/>
                                  <path d="M11.339,11.571c1.652,0,2.991-1.339,2.991-2.991c0-1.652-2.991-5.528-2.991-5.528S8.348,6.928,8.348,8.58
                                      C8.348,10.232,9.687,11.571,11.339,11.571"/>
                              </svg>`,

        'kickstand': `<svg viewBox="0 0 22.676 22.138">
                                  <path d="M14.959,0.052L13.638,11.59h-4.45L7.861,0C3.301,1.468,0,5.747,0,10.795c0,6.263,5.076,11.342,11.338,11.342
                                      c6.262,0,11.338-5.081,11.338-11.343C22.676,5.799,19.443,1.564,14.959,0.052 M15.563,14.59c0,1.325-1.016,2-2.27,2H9.509
                                      c-1.254,0-2.27-0.675-2.27-2c0-1.324,1.016-2,2.27-2h3.784C14.547,12.59,15.563,13.266,15.563,14.59"/>
                              </svg>`,
        'plastic_basket': `<svg viewBox="0 0 22.7 22.7">
                                <g>
                                  <path d="M7,15.8l2.3,2.3c0.8-0.3,1.5-0.9,1.8-1.7l0.4-1.2l-1.9-1.9L7,15.8z"/>
                                  <path d="M5.7,15.8l-2.5-2.5l-2.4,2.4c0.4,0.9,0.9,1.8,1.5,2.6h0.9L5.7,15.8z"/>
                                  <polygon points="11.7,14.3 13.1,9.7 10.1,12.7 	"/>
                                  <path d="M0.1,10.2C0,10.6,0,10.9,0,11.3c0,1.2,0.2,2.4,0.5,3.4l2.1-2.1L0.1,10.2z"/>
                                  <path d="M5.7,9.6L3.5,7.4H0.7C0.5,7.9,0.3,8.5,0.2,9.1l3,3L5.7,9.6z"/>
                                  <polygon points="7.9,7.4 4.8,7.4 6.4,9 	"/>
                                  <polygon points="9.5,12.1 13.6,8 13.8,7.4 9.2,7.4 7,9.6 	"/>
                                  <path d="M11.3,0C7.8,0,4.6,1.6,2.5,4.2h10.8h1.2c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7h-1.2H2.5h-1
                                    C1.4,5.9,1.2,6.2,1.1,6.5H15l-3.1,10.2c-0.4,1.4-1.9,2.5-3.3,2.5H3.1c2.1,2.2,5,3.5,8.2,3.5c6.3,0,11.3-5.1,11.3-11.3
                                    S17.6,0,11.3,0z"/>
                                  <polygon points="4.5,18.3 8.2,18.3 6.4,16.5 	"/>

                                    <rect x="4.6" y="10.9" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -7.1324 8.2187)" width="3.6" height="3.6"/>
                                </g>
                                </svg>`
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Graphics/BikeFeatures.vue